import { IDevice } from "@edp-models/device.model";

export interface INotificationsState {
    optOut: boolean;
    device: IDevice;
    pushConfigs: any;
}

export const initialNotificationsState: INotificationsState = {
    optOut: false,
    device: null,
    pushConfigs: null
};
